import { Box, CircularProgress, TableCell, TableRow } from "@mui/material"

export function LegislationLibraryLoadingRow({ colSpan = 4 }) {
    return (
        <TableRow>
            <TableCell colSpan={colSpan}>
                <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
                    <CircularProgress size={48} />
                </Box>
            </TableCell>
        </TableRow>
    )
}
